<div class="t-a-c">
    <p>
      {{msg}}
  	</p>
	<button mat-flat-button (click)="ok()" class="m-r-5 error-btn-msg">
		OK
	</button>			
</div>
